export default __webpack_public_path__ + "static/media/Insertphoto.4289512d.svg";